'use strict';

module.exports = '2.19.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 337
// module chunks = 0